import http from "../../http-common"

class NewsService {
    getAllNews() {
        return http.get(`/who-we-are/news`)
    }  
}

export default new NewsService();